import { render, staticRenderFns } from "./users-register.page.vue?vue&type=template&id=1f98e33a"
import script from "./users-register.page.vue?vue&type=script&lang=ts"
export * from "./users-register.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports